import { useEffect, useState } from "react";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Drawer,
} from "@mui/material";
import { Link } from "react-router-dom";
import {
  Group as GroupIcon,
  Event as EventIcon,
  VideoChat as VideoChatIcon,
  CardMembership as CardMembershipIcon,
} from "@mui/icons-material";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import VideoFileIcon from "@mui/icons-material/VideoFile";
import HomeIcon from "@mui/icons-material/Home";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import "react-pro-sidebar/dist/css/styles.css";

const AdminSidebar = () => {
  const arole = localStorage.getItem("arole");
  let defaultSelected;
  if (arole === "admin") {
    defaultSelected = "DashBoard";
  } else if (arole === "sales") {
    defaultSelected = "Search_User";
  } else if (arole === "accounts") {
    defaultSelected = "DashBoard";
  } else if (arole === "academy" || arole==="catalyst") {
    defaultSelected = "Events";
  } else {
    defaultSelected = "DashBoard";
  }

  const [selected, setSelected] = useState(defaultSelected);

  const [formData, setFormData] = useState({
    DashBoard: false,
    User: false,
    member: false,
    event: false,
    course: false,
    videos: false,
    Resource: false,
    SearchUser: false,
  });

  useEffect(() => {
    if (arole === "admin") {
      setFormData((prevState) => ({
        ...prevState,
        DashBoard: true,
        User: true,
        member: true,
        event: true,
        course: true,
        videos: true,
        Resource: true,
        SearchUser: true
      }));
    } else if (arole === "sales") {
      setFormData((prevState) => ({
        ...prevState,
        DashBoard: false,
        User: false,
        member: false,
        event: false,
        course: false,
        videos: false,
        Resource: false,
        SearchUser: true
      }));
    } else if (arole === "accounts") {
      setFormData((prevState) => ({
        ...prevState,
        DashBoard: true,
        User: true,
        member: false,
        event: false,
        course: false,
        videos: false,
        Resource: false,
        SearchUser: false
      }));
    } else if (arole === "academy" || arole==="catalyst") {
      setFormData((prevState) => ({
        ...prevState,
        DashBoard: false,
        User: false,
        member: false,
        event: true,
        course: arole==="catalyst"? false : true,
        videos:  arole==="catalyst"? false : true,
        Resource:  arole==="catalyst"? false : true,
        SearchUser: arole==="catalyst"? true : false,
      }));
    }
  }, [arole]);

  const handleSectionClick = (section) => {
    setSelected(section);
  };

  // This function checks if the section is selected
  const isSelected = (section) => selected === section;

  return (
    <Drawer
      sx={{
        "& .MuiDrawer-paper": {
          width: 240,
          boxSizing: "border-box",
          marginTop: "64px",
          height: "100vh",
          backgroundColor: "#E9F3F5",
          color: "#000000",
        },
      }}
      variant="permanent"
      anchor="left"
    >
      <List>
        {/* Dashboard Section */}
        {formData.DashBoard && (
          <Link to="/Admin/AdminDashBoard">
            <ListItem
              onClick={() => handleSectionClick("DashBoard")}
              sx={{
                "&:hover": { backgroundColor: "#F7F5EF" },
                backgroundColor: isSelected("DashBoard")
                  ? "#D0E8F5"
                  : "transparent",
                marginBottom: "10px",
              }}
            >
              <ListItemIcon sx={{ color: "#000000" }}>
                <HomeIcon />
              </ListItemIcon>

              <ListItemText primary="DashBoard" sx={{ color: "#000000" }} />
            </ListItem>
          </Link>
        )}

        {/* Users Section */}
        {formData.User && (
          <Link to="/Admin/ShraddhaAdminUser">
            <ListItem
              onClick={() => handleSectionClick("Users")}
              sx={{
                "&:hover": { backgroundColor: "#F7F5EF" },
                backgroundColor: isSelected("Users")
                  ? "#D0E8F5"
                  : "transparent",
                marginBottom: "10px",
              }}
            >
              <ListItemIcon sx={{ color: "#000000" }}>
                <GroupIcon />
              </ListItemIcon>

              <ListItemText primary="Users" sx={{ color: "#000000" }} />
            </ListItem>
          </Link>
        )}

        {/* Search Section */}
        {formData.SearchUser && (
        <Link to="/Admin/UserSearch">
          <ListItem
            onClick={() => handleSectionClick("Search_User")}
            sx={{
              "&:hover": { backgroundColor: "#F7F5EF" },
              backgroundColor: isSelected("Search_User")
                ? "#D0E8F5"
                : "transparent",
              marginBottom: "10px",
            }}
          >
            <ListItemIcon sx={{ color: "#000000" }}>
              <PersonSearchIcon />
            </ListItemIcon>

            <ListItemText primary="Search_User" sx={{ color: "#000000" }} />
          </ListItem>
        </Link>
        )}

        {/* Infinite Member Section */}
        {formData.member && (
          <Link to="/Admin/ShraddhaInfiniteMember">
            <ListItem
              onClick={() => handleSectionClick("Infinite Member")}
              sx={{
                "&:hover": { backgroundColor: "#F7F5EF" },
                backgroundColor: isSelected("Infinite Member")
                  ? "#D0E8F5"
                  : "transparent",
                marginBottom: "10px",
              }}
            >
              <ListItemIcon sx={{ color: "#000000" }}>
                <CardMembershipIcon />
              </ListItemIcon>

              <ListItemText
                primary="Infinite Member"
                sx={{ color: "#000000" }}
              />
            </ListItem>
          </Link>
        )}
        {/* Events Section */}
        {formData.event && (
          <Link to="/Admin/ShraddhaAdminEvent">
            <ListItem
              onClick={() => handleSectionClick("Events")}
              sx={{
                "&:hover": { backgroundColor: "#F7F5EF" },
                backgroundColor: isSelected("Events")
                  ? "#D0E8F5"
                  : "transparent",
                marginBottom: "10px",
              }}
            >
              <ListItemIcon sx={{ color: "#000000" }}>
                <EventIcon />
              </ListItemIcon>

              <ListItemText primary="Events" sx={{ color: "#000000" }} />
            </ListItem>
          </Link>
        )}
        {/* Infinite Courses Section */}
        {formData.course && (
          <Link to="/Admin/AdminCourses">
            <ListItem
              onClick={() => handleSectionClick("Courses")}
              sx={{
                "&:hover": { backgroundColor: "#F7F5EF" },
                backgroundColor: isSelected("Courses")
                  ? "#D0E8F5"
                  : "transparent",
                marginBottom: "10px",
              }}
            >
              <ListItemIcon sx={{ color: "#000000" }}>
                <OndemandVideoIcon />
              </ListItemIcon>

              <ListItemText primary="Courses" sx={{ color: "#000000" }} />
            </ListItem>
          </Link>
        )}
        {/* Training Videos Section */}
        {formData.videos && (
          <Link to="/Admin/ShraddhaAdminTraning">
            <ListItem
              onClick={() => handleSectionClick("Training Videos")}
              sx={{
                "&:hover": { backgroundColor: "#F7F5EF" },
                backgroundColor: isSelected("Training Videos")
                  ? "#D0E8F5"
                  : "transparent",
                marginBottom: "10px",
              }}
            >
              <ListItemIcon sx={{ color: "#000000" }}>
                <VideoChatIcon />
              </ListItemIcon>

              <ListItemText
                primary="Training Videos"
                sx={{ color: "#000000" }}
              />
            </ListItem>
          </Link>
        )}
        {/* Training Videos resource */}
        {formData.Resource && (
          <Link to="/Admin/VideoResourses">
            <ListItem
              onClick={() => handleSectionClick("Videos Resources")}
              sx={{
                "&:hover": { backgroundColor: "#F7F5EF" },
                backgroundColor: isSelected("Videos Resources")
                  ? "#D0E8F5"
                  : "transparent",
                marginBottom: "10px",
              }}
            >
              <ListItemIcon sx={{ color: "#000000" }}>
                <VideoFileIcon />
              </ListItemIcon>

              <ListItemText
                primary="Videos Resources"
                sx={{ color: "#000000" }}
              />
            </ListItem>
          </Link>
        )}
      </List>
    </Drawer>
  );
};

export default AdminSidebar;
